export enum CodeDomaine {
  ALIMENTS = 'ALIMENTS',
  ENGRAIS = 'ENGRAIS'
}
